<template>
  <el-dialog
    v-if="visible"
    :width="width"
    :visible="visible"
    :close-on-click-modal="false"
    :title="title"
    @close="close"
    custom-class="printDialog"
    append-to-body
  >
    <template #title>
      <div class="printTitle">{{ title }}</div>
    </template>
    <div v-loading="loading">
      <!-- 固定资产折旧表-->
      <fixedAssetsTable
        :isReadonly="isReadonly"
        :currentPage="currentPage"
        :tableData="fixedData.data[fixedData.currentPage]"
        ref="fixedAssetsTable"
        v-if="type == 1"
        :previousTotal="previousTotal"
      ></fixedAssetsTable>

      <!-- 工资表-->
      <payrollTable
        :isReadonly="isReadonly"
        ref="payrollTable"
        :currentPage="currentPage"
        :previousTotal="previousTotal"
        :tableData="payRollData.data[payRollData.currentPage]"
        v-if="type == 2"
      ></payrollTable>
      <!-- 摊销表-->
      <AmortizationTable
        :isReadonly="isReadonly"
        ref="AmortizationTable"
        v-if="type == 3"
        :previousTotal="previousTotal"
        :currentPage="currentPage"
        :tableData="AmortizationData.data[AmortizationData.currentPage]"
      ></AmortizationTable>

      <!-- 费用报销表-->
      <Reimbursement
        v-if="type == 4"
        :isReadonly="isReadonly"
        ref="Reimbursement"
        :currentPage="currentPage"
        :tableData="ReimbursementData.data[ReimbursementData.currentPage]"
      ></Reimbursement>
      <div class="footer">
        <div class="page">
          <div
            class="add"
            @click="addPage"
            v-show="currentData.currentPage == currentData.total"
          >
            <i class="el-icon-circle-plus-outline" style="margin-top: 2px"></i>
            <div>添加一页</div>
          </div>
          <div class="changePage">
            <span class="iconPosition">
              <i
                :class="noPerv ? 'el-icon left-n' : 'el-icon left'"
                @click="caseVoucher('prev')"
                title="上一张"
              ></i>
              <span
                >{{ currentPage }}/<span style="color: #666666">{{
                  totalPage
                }}</span></span
              >
              <i
                :class="noNext ? 'el-icon right-n' : 'el-icon right'"
                @click="caseVoucher('next')"
                title="下一张"
              ></i>
            </span>
          </div>
        </div>
        <div class="btn">
          <div class="reset" @click="resest">重置</div>
          <div class="edit" v-if="isReadonly">编辑</div>
          <div class="submit" @click="saveTemplate">确定</div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import payrollTable from "../table/payrollTable.vue";
import fixedAssetsTable from "../table/fixedAssetsTable.vue";
import AmortizationTable from "../table/AmortizationTable.vue";
import Reimbursement from "../table/Reimbursement.vue";
import {
  findFixedAssets,
  findPayRoll,
  findAmortization,
  findExpenseReimbursementList,
} from "@/api";
import {
  ReimbursementFiled,
  assetsTableFiled,
  payRollTableFiled,
  AmortizationTableFiled,
} from "@/assets/js/printTemplate.js";
export default {
  components: {
    Reimbursement,
    AmortizationTable,
    payrollTable,
    fixedAssetsTable,
  },
  props: {
    backShow: {
      type: Object,
      default: () => {},
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String | Number,
      default: 1, //1 固定资产 2.工资表  3.摊销表 4.报销表
    },
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal) {
          this.open();
          // this.$nextTick(()=>{
          //   this.defaultGenerate = true;
          // })
        }
        console.log(newVal, "key");
      },
      immediate: true,
    },
  },
  computed: {
    width() {
      return this.type == 2 ? "1220px" : "882px";
    },
    currentPage() {
      const data = this.getData().data;
      return data.currentPage;
    },
    previousTotal() {
      const data = this.getData().data;
      let total = 0;
      for (let i in data.data) {
        if (i < data.currentPage) {
          total += data.data[i].length;
        }
      }
      return total;
    },
    totalPage() {
      const data = this.getData().data;
      return data.total;
    },
    noPerv() {
      const data = this.getData().data;
      return data.currentPage <= data.total && data.currentPage == 1
        ? true
        : false;
    },
    noNext() {
      const data = this.getData().data;
      return data.currentPage < data.total ? false : true;
    },
    currentData() {
      const data = this.getData().data;
      return data;
    },
    currentFiled() {
      const obj = {
        1: this.assetsTableFiled,
        2: this.payRollTableFiled,
        3: this.AmortizationTableFiled,
        4: this.ReimbursementFiled,
      };
      return obj[this.type];
    },
  },
  data() {
    return {
      defaultGenerate: false,
      resizePageLoading: false,
      loading: false,
      ReimbursementFiled,
      AmortizationTableFiled,
      assetsTableFiled,
      payRollTableFiled,
      payRollData: {
        currentPage: 1, // 当前页码
        total: 1,
        data: {
          1: [],
        },
        file: {
          1: {},
        },
      },
      ReimbursementData: {
        currentPage: 1, // 当前页码
        total: 1,
        data: {
          1: [],
        },
        file: {
          1: {},
        },
      },
      AmortizationData: {
        currentPage: 1, // 当前页码
        total: 1,
        data: {
          1: [],
        },
        file: {
          1: {},
        },
      },
      fixedData: {
        currentPage: 1, // 当前页码
        total: 1,
        data: {
          1: [],
        },
        file: {
          1: {},
        },
      },
      jsonData: {},
    };
  },
  methods: {
    //** 保存时候重新计算分页 */
    slicePageTask(list) {
      // const ref = this.getData().ref;
      // const data = this.getData().data;
      // this.$refs[ref].changeEdit(true);
      // this.$set(data, "currentPage", 1);
      // this.$set(data, "total", 1);
      // this.$set(data, "data", { 1: list });
      // this.$set(data, "file", { 1: {} });
      // this.$nextTick(() => {
      //   let tableElHeight = 0;
      //   if (this.type == 1) {
      //     tableElHeight = document
      //       .querySelector("#fixedAssets")
      //       .querySelector(".el-table").clientHeight;
      //   } else if (this.type == 2) {
      //     tableElHeight = document
      //       .querySelector("#payrollTable")
      //       .querySelector(".el-table").clientHeight;
      //   } else if (this.type == 3) {
      //     tableElHeight = document
      //       .querySelector("#AmortizationTable")
      //       .querySelector(".el-table").clientHeight;
      //   }
      //   const spliceNum = Math.floor((tableElHeight - (596 - 60)) / 30);
      //   console.log(tableElHeight);
      // });
    },
    //默认生成图片
    async generateImageTask() {
      console.log(11111111111111111);
      const data = this.getData().data;
      const ref = this.getData().ref;
      this.loading = true;
      for (let i = 0; i < data.total; i++) {
        this.$set(data, "currentPage", i + 1);
        const fileData = await this.$refs[ref].generateImage(true);
        this.$set(data.file, data.currentPage, fileData);
        console.log(fileData);
      }
      this.loading = false;
      this.$set(data, "currentPage", 1);
      this.$refs[ref].changeEdit(false);
      this.defaultGenerate = true;
      console.log(data);
    },
    async saveTemplate() {
      const ref = this.getData().ref;
      const data = this.getData().data;
      let list = [];
      for (let i in data.data) {
        list = list.concat(data.data[i]);
      }
      // if (this.type != 4) {
      //   // data.data[data.currentPage] = list;  //将所有数组重新合并 重新计算分页
      //   this.slicePageTask(list); //将所有数组重新合并 重新计算分页
      //   return;
      // }
      this.loading = true;

      const fielData = await this.$refs[ref].generateImage(true);
      data.file[data.currentPage] = fielData;
      this.$refs[ref].changeEdit(false);
      this.loading = false;
      this.$emit("saveTemplate", data);
      this.close();
    },
    async addPage() {
      const data = this.getData().data;
      const ref = this.getData().ref;
      const list = data.data[data.currentPage];
      let keys = false;
      console.log(list);
      if (this.type == 4) {
        keys = list
          .map((item) => {
            let itemKey = false;
            let itemChildKey = false;
            for (let key in item) {
              if (item[key]) {
                itemKey = true;
              }
            }
            item.item.map((child) => {
              for (let key in child) {
                if (child[key]) {
                  itemChildKey = true;
                }
              }
            });
            return itemKey && itemChildKey ? true : false;
          })
          .every((item) => item);
      } else {
        keys = list
          .map((item) => {
            let itemKey = false;
            for (let key in item) {
              if (item[key]) {
                itemKey = true;
              }
            }
            return itemKey;
          })
          .every((item) => item);
      }
      if (!keys) {
        this.$message({
          message: "请先填写完整当前页的数据",
          type: "warning",
        });
        return;
      } else {
        this.loading = true;
        const fileData = await this.$refs[ref].generateImage(true);
        // this.$set(data,'file',)
        data.file[data.currentPage] = fileData;
        this.$refs[ref].changeEdit(false);
        this.loading = false;
        this.$set(data, "currentPage", data.currentPage + 1);
        this.$set(data, "total", data.total + 1);
        this.$set(data, "data", { ...data.data, [data.currentPage]: [] });
        this.$set(data, "file", { ...data.file, [data.currentPage]: {} });
        console.log("123213", ...data.data, [data.currentPage]);
        if (this.type == 4) {
          this.ReimbursementData.data[data.currentPage] =
            this.getReimBursementList();
          return;
        }
        this.$nextTick(() => {
          this.resizePage([], data.currentPage, {}, data.currentPage, true);
        });
      }
    },
    //动态分页
    resizePage(list, page, file, currentPage) {
      console.log(file, "截图的文件列表", page, currentPage);
      let tableElHeight = 0;
      let slicedArray = [];
      const currentData = this.getData().data;
      if (this.type == 1) {
        tableElHeight = document
          .querySelector("#fixedAssets")
          .querySelector(".el-table").clientHeight;
      } else if (this.type == 2) {
        tableElHeight = document
          .querySelector("#payrollTable")
          .querySelector(".el-table").clientHeight;
      } else if (this.type == 3) {
        tableElHeight = document
          .querySelector("#AmortizationTable")
          .querySelector(".el-table").clientHeight;
      }
      if (tableElHeight > 596 - 60) {
        //根据每条30的基础来算将多余的条数截取掉 放到第二页 进入第二页再继续往后推算
        const spliceNum = Math.floor((tableElHeight - (596 - 60)) / 30);
        if (spliceNum == 0) return false;
        console.log(spliceNum, "需要分页");
        const startIndex = Math.max(list.length - spliceNum, 0);
        const defaultArray = list.slice(0, list.length - spliceNum);
        slicedArray = list.slice(startIndex);
        let obj = Object.assign(currentData.data);
        let fileObj = Object.assign(currentData.file);
        fileObj[currentPage] = file;
        obj[page] = defaultArray;
        const slicePage = Math.ceil(spliceNum / 14);
        console.log(slicedArray, "kkkkkkkkk");
        if (slicePage > 0) {
          let remainingArray = [...slicedArray]; // 复制一份数组
          for (let i = 1; i <= slicePage; i++) {
            const currentPageData = remainingArray.slice(0, 14);
            obj[page + i] = currentPageData;
            remainingArray = remainingArray.slice(14);
            console.log(currentPageData);
          }
        } else {
          obj[page + 1] = slicedArray;
        }

        // console.log(slicePage,'需要分页的页数',slicedArray)

        this.$set(currentData, "currentPage", page);
        if (page == currentData.total) {
          this.$set(currentData, "total", currentData.total + slicePage);
        }
        // this.$set(currentData, "total", currentData.total + 1);
        this.$set(currentData, "data", obj);
        this.$set(currentData, "file", fileObj);
      } else {
        let getNum = Math.floor((596 - 60 - tableElHeight) / 30);
        console.log(getNum, "不要分页，需要补充的条数");
        for (let i = 0; i < getNum - 1; i++) {
          let obj = {};
          this.currentFiled.forEach((item) => {
            obj[item] = "";
          });
          slicedArray.push(obj);
        }
        currentData.file[currentPage] = file;
        currentData.data[page].push(...slicedArray);
      }
      if (!this.defaultGenerate) {
        this.$nextTick(() => {
          this.generateImageTask();
        });
      }
      console.log(currentData, "分页数据");
    },
    getReimBursementList() {
      let list = [];
      let obj = {};
      this.currentFiled.forEach((item) => {
        if (
          Object.prototype.toString.call(item) === "[object Object]" &&
          item.children &&
          item.children.length
        ) {
          let childObj = {};
          item.children.forEach((child) => {
            childObj[child] = "";
          });
          obj[item.name] = [];
          for (let i = 0; i < 5; i++) {
            obj[item.name].push({ ...childObj });
          }
        } else {
          obj[item] = "";
        }
      });
      list[0] = obj;
      return list;
    },
async getDataInfo(arr) {
  try {
    this.loading = true;
    const request = {
      1: findFixedAssets,
      2: findPayRoll,
      3: findAmortization,
      4: findExpenseReimbursementList,
    };
    const currentInfo = this.getData().data;
    const httpFn = request[this.type];
    
    // 1. 获取原始数据
    const res = await httpFn();
    const remoteData = res.data.code == 1 ? res.data.data : [];
    let list = arr && arr.length > 0 ? arr : remoteData;

    if (list.length > 0) {
      // 2. 格式化日期字段（保持你原有的逻辑）
      const formattedList = list.map((item) => {
        if (item.hasOwnProperty("startUse") && item["startUse"]) {
          item["startUse"] = this.$formart(item["startUse"], "yyyy-MM");
        }
        if (item.hasOwnProperty("date") && item["date"]) {
          item["date"] = this.$formart(item["date"], "yyyy-MM-dd");
        }
        return item;
      });

      if (this.type != 4) {
        // --- 核心修复：物理分页切分 ---
        const pageSize = 14; // 每页基础条数
        const totalPage = Math.ceil(formattedList.length / pageSize);
        
        // 重置当前模块的数据容器，防止旧数据干扰
        this.$set(currentInfo, "data", {});
        
        for (let i = 0; i < totalPage; i++) {
          const pageData = formattedList.slice(i * pageSize, (i + 1) * pageSize);
          this.$set(currentInfo.data, i + 1, pageData);
        }

        this.$set(currentInfo, "total", totalPage || 1);
        this.$set(currentInfo, "currentPage", 1);

        // 3. 触发高度微调逻辑
        // 这一步是为了防止某行内容过多（换行）导致 14 条也超高，利用你原有的 resizePage 检查
        this.$nextTick(() => {
          this.resizePage(currentInfo.data[1], 1, {}, 1);
        });
        
      } else {
        // 费用报销表（Type 4）逻辑：保持一页一条
        this.$set(currentInfo, "total", formattedList.length);
        formattedList.forEach((item, index) => {
          this.$set(currentInfo.data, index + 1, [item]);
        });
        // 报销单通常直接生成图片任务
        this.generateImageTask();
      }
    } else {
      // 4. 空数据处理：默认生成 14 条空行
      let emptyList = [];
      if (this.type == 4) {
        emptyList = this.getReimBursementList();
      } else {
        for (let i = 0; i < 14; i++) {
          let obj = {};
          this.currentFiled.forEach((key) => {
            obj[key] = "";
          });
          emptyList.push(obj);
        }
      }
      this.defaultGenerate = true;
      this.$set(currentInfo, "currentPage", 1);
      this.$set(currentInfo, "total", 1);
      this.$set(currentInfo, "data", { 1: emptyList });
      this.$set(currentInfo, "file", { 1: {} });
    }
  } catch (error) {
    console.error("获取数据并处理分页失败:", error);
  } finally {
    this.loading = false;
  }
},
    getData() {
      let obj = {
        1: { data: this.fixedData, ref: "fixedAssetsTable" },
        2: { data: this.payRollData, ref: "payrollTable" },
        3: { data: this.AmortizationData, ref: "AmortizationTable" },
        4: { data: this.ReimbursementData, ref: "Reimbursement" },
      };
      return obj[this.type];
    },
    resest(key) {
      let currentInfo = this.getData().data;
      this.$set(currentInfo, "currentPage", 1);
      this.$set(currentInfo, "total", 1);
      this.$set(currentInfo, "data", { 1: [] });
      this.$set(currentInfo, "file", { 1: {} });
      if (this.type == 4) {
        this.$set(currentInfo, "data", { 1: this.getReimBursementList() });
      }
      if (key == true) return;
      this.getDataInfo([]);
    },
    async caseVoucher(key) {
      if (key == "next" && this.noNext) return;
      if (key == "prev" && this.noPerv) return;
      const data = this.getData().data;
      const ref = this.getData().ref;
      console.log(data, "打印的数据");
      this.jsonData = JSON.parse(JSON.stringify(this.getData().data));
      this.loading = true;
      const fileData = await this.$refs[ref].generateImage(true);
      const page = key == "next" ? data.currentPage + 1 : data.currentPage - 1;
      this.$set(data, "currentPage", page);
      if (this.type != 4) {
        this.$nextTick(() => {
          this.resizePage(
            data.data[page],
            page,
            fileData,
            this.jsonData.currentPage
          );
        });
      }
      this.loading = false;
      this.$refs[ref].changeEdit(false);
      console.log(this.getData(), "打印的数据", this.jsonData.currentPage,ref);
    },
    close() {
      this.$emit("update:visible", false);
    },
    // 在 methods 中添加此方法
  initialSplice(list) {
    const currentInfo = this.getData().data;
    if (!list || list.length === 0) return;

    // 如果是报销单(type 4)，逻辑按原有的走
    if (this.type == 4) {
      currentInfo.total = list.length;
      list.forEach((item, index) => {
        this.$set(currentInfo.data, index + 1, [item]);
      });
      return;
    }

    // 其他表：每 14 条切分为一页
    const pageSize = 14;
    const totalPage = Math.ceil(list.length / pageSize);
    
    let newDataObj = {};
    for (let i = 0; i < totalPage; i++) {
      newDataObj[i + 1] = list.slice(i * pageSize, (i + 1) * pageSize);
    }

    this.$set(currentInfo, "data", newDataObj);
    this.$set(currentInfo, "total", totalPage || 1);
    this.$set(currentInfo, "currentPage", 1);
  },
open() {
  console.log("执行打开初始化");
  this.resest(true); // 先重置
  this.$nextTick(() => {
    const list = this.backShow[this.type] || [];
    console.log(list, "回显的数据");
    this.defaultGenerate = false;

    // --- 修改点：不再直接在 getDataInfo 里硬塞，而是先做物理切分 ---
    if (list.length > 0) {
      this.initialSplice(list); // 先按14条物理切分页
      
      // 然后再执行 getDataInfo 去处理日期格式化和补全逻辑
      this.getDataInfo(list); 
    } else {
      this.getDataInfo([]); // 走默认空行逻辑
    }
  });
},
  },
};
</script>

<style lang="less" scoped>
.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  .page,
  .btn {
    display: flex;
    align-items: center;
  }
  .page {
    gap: 40px;
    .add {
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 14px;
      color: #269d7b;
    }
    .iconPosition {
      display: flex;
      align-items: center;
      gap: 30px;
      i.el-icon {
        display: inline-block;
        width: 24px;
        height: 24px;
        // margin-left: 16px;
        // line-height: 25px;
        cursor: pointer;
        &.left {
          background: url("/static/btn/before_n.png") no-repeat center;
        }
        &.left-n {
          background: url("/static/btn/before_d.png") no-repeat center;
        }
        &.right {
          background: url("/static/btn/after_n.png") no-repeat center;
        }
        &.right-n {
          background: url("/static/btn/after_d.png") no-repeat center;
        }
      }
    }
  }
  .btn {
    gap: 10px;
    & > div {
      width: 100px;
      text-align: center;
      padding: 6px;
      box-sizing: border-box;
      cursor: pointer;
      border-radius: 4px;
    }
    .reset,
    .edit {
      color: #269d7b;
      background: rgba(38, 157, 123, 0.1);
    }
    .submit {
      color: #ffffff;
      background: rgba(38, 157, 123, 1);
    }
  }
}
.printTitle {
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 20px;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/printTable.vue